var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ blueBtn: _vm.load }},[(!_vm.load)?_vm._t("default"):_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"bounce1"}),_c('div',{staticClass:"bounce2"}),_c('div',{staticClass:"bounce3"})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }